import { reactive } from 'vue'
export const chronicDiseases = reactive([
    {
        isSelected: false,
        name: "AIDS",
        code: "042"
    },

    {
        isSelected: false,
        name: "AIDs-related complex",
        code: "043"
    },

    {
        isSelected: false,
        name: "Other human immunodeficiency virus infection",
        code: "044"
    },

    {
        isSelected: false,
        name: "Diabetes mullitus, including complications",
        code: "250"
    },

    {
        isSelected: false,
        name: "Coagulation defects (e.g. haemophilia, other factor deficiencies)",
        code: "286"
    },

    {
        isSelected: false,
        name: "Purpura, thrombocytopenia, other haemorrhagic conditions",
        code: "287"
    },

    {
        isSelected: false,
        name: "Senile dementia, presenile dementia",
        code: "290"
    },

    {
        isSelected: false,
        name: "Child psychosis or autism",
        code: "299"
    },

    {
        isSelected: false,
        name: "Behavioural disorders of childhood and adolescence",
        code: "313"
    },

    {
        isSelected: false,
        name: "Specified delays in development (e.g. dyslexia, dyslalia, motor retardation)",
        code: "315"
    },


    {
        isSelected: false,
        name: "Parkinson's Disease",
        code: "332"
    },

    {
        isSelected: false,
        name: "Multiple Sclerosis",
        code: "340"
    },

    {
        isSelected: false,
        name: "Cerebral Palsy",
        code: "343"
    },

    {
        isSelected: false,
        name: "Epilepsy",
        code: "345"
    },

    {
        isSelected: false,
        name: "Hypertensive Heart Disease ",
        code: "402"
    },

    {
        isSelected: false,
        name: "Congestive Heart Failure",
        code: "428"
    },

    {
        isSelected: false,
        name: "Chronic Bronchitis ",
        code: "491"
    },

    {
        isSelected: false,
        name: "Emphysema",
        code: "492"
    },

    {
        isSelected: false,
        name: "Asthma, Allergic Bronchitis",
        code: "493"
    },

    {
        isSelected: false,
        name: "Pulmonary Fibrosis",
        code: "515"
    },

    {
        isSelected: false,
        name: "Regional Enteritis, Crohn's Disease",
        code: "555"
    },

    {
        isSelected: false,
        name: "Ulcerative Colitis",
        code: "556"
    },

    {
        isSelected: false,
        name: "Cirrhosis of the Liver",
        code: "571"
    },

    {
        isSelected: false,
        name: "Chronic Renal Failure, Uremia ",
        code: "585"
    },

    {
        isSelected: false,
        name: "Disseminated Lupus Erythaematosus, Generalized Scleroderma, Dermat",
        code: "710"
    },


    {
        isSelected: false,
        name: "Rheumatoid Arthritis, Still's Disease",
        code: "714"
    },

    {
        isSelected: false,
        name: "Ankylosing Spondylitis",
        code: "720"
    },

    {
        isSelected: false,
        name: "Other seronegative spondyloarthropathies",
        code: "721"
    },

    {
        isSelected: false,
        name: "Chromosomal Anomalies ",
        code: "758"
    },

    {
        isSelected: false,
        name: "Prematurity, low birth weight infant ",
        code: "765"
    },

    {
        isSelected: false,
        name: "Educational problems",
        code: "902"
    },

]);

/**
 * Resets all the disease objects to false
 */
export function resetDiseaseObjects() {
    chronicDiseases.forEach(disease => {
        disease.isSelected = false;
    })
}